module.exports = __webpack_public_path__ + "static/media/Lifeguard.7bd39856.jpg";